import React from 'react';
import SlidingSidePanel from 'components/ExperienceCanvas/SlidingSidePanel/SlidingSidePanel';
import { TSlidingSidePanelProps } from 'components/ExperienceCanvas/types';
import FlowFileUpload from '../FlowFileUpload/FlowFileUpload';
import FlowFileUploadHistory from '../FlowFileUploadHistory/FlowFileUploadHistory';
import './FlowContextDataSlideOut.scss';

type TFlowContextDataSlideOutProps = {
  isOpen: boolean;
  onClickClose: () => void;
};

const MAIN_CLASS = 'flow-context-data-slide-out';
const CLASSES = {
  FILE_HISTORY_WRAPPER: `${MAIN_CLASS}__file-history-wrapper`,
  FILE_UPLOAD_WRAPPER: `${MAIN_CLASS}__file-upload-wrapper`,
};

const FlowContextDataSlideOut: React.FC<TFlowContextDataSlideOutProps> = ({ isOpen, onClickClose }) => {
  const slidingSidePanelProps: TSlidingSidePanelProps = {
    headerInfo: {
      mainTitle: 'Upload Context Data',
      showCloseButton: true,
      goBackActionHandler: onClickClose,
    },
    footerInfo: {
      secondaryActionHandler: onClickClose,
    },
    showFooter: false,
    show: isOpen,
  };

  return (
    <SlidingSidePanel {...slidingSidePanelProps}>
      <div className={MAIN_CLASS}>
        <div className={CLASSES.FILE_UPLOAD_WRAPPER}>
          <FlowFileUpload allowedTypes={['text/csv']} showDownloadSampleFile />
        </div>
        <div className={CLASSES.FILE_HISTORY_WRAPPER}>
          <FlowFileUploadHistory />
        </div>
      </div>
    </SlidingSidePanel>
  );
};

export default FlowContextDataSlideOut;
